export function useUserEmailPreferences() {
  const { fetchUserInfo } = useHubSpotUser()
  const authStore = useAuthStore()

  watch(
    () => authStore.authenticated,
    async () => {
      if (!authStore.authenticated) return
      await fetchUserInfo()
    },
    {
      immediate: true,
    },
  )

  return {
    hasCopperWeekly: computed(
      () => authStore.hubSpotUser?.is_subscribed_to_copper_weekly,
    ),

    hasBenchmarkNewsletter: computed(
      () => authStore.hubSpotUser?.is_subscribed_to_benchmark_newsletter,
    ),

    hasPolicyNewsletter: computed(
      () => authStore.hubSpotUser?.is_subscribed_to_policy_newsletter,
    ),

    hasPriceSpotlight: computed(
      () => authStore.hubSpotUser?.is_subscribed_to_price_spotlight,
    ),
  }
}
